import { saveSearch as saveSearchReq } from '@/services/search.services'

export const useSaveSearch = () => {
  const saveSearch = (searchParams: { [key: string]: any }) => {
    saveSearchReq(searchParams)
  }
  return {
    saveSearch
  }
}
